import React, { ReactElement } from "react";
import { Table } from "antd";
import { AdsWithoutPdfsRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Uuid",
    dataIndex: "uuid",
  },
  {
    title: "PDF File Name",
    dataIndex: "pdf_file_name",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Cluster_id",
    dataIndex: "cluster_id",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Pipeline Flags",
    dataIndex: "pipeline_flags",
  },
];

type AdsWithoutPdfsProps = {
  loading: boolean;
  records: Array<AdsWithoutPdfsRecord>;
};

const AdsWithoutPdfs = ({ loading, records }: AdsWithoutPdfsProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="uuid"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default AdsWithoutPdfs;
